
import { mapState } from 'vuex';
import ResourceView from '@/mixins/ResourceView';
import MileageNoticeHelper from '@/mixins/MileageNoticeHelper';
import DropdownMenuWidth from '@/enums/DropdownMenuWidth';
import ReviewSort from '@/enums/ReviewSort';

export default {
  i18nComponentKey: 'ManagingReviews.components.PendingReviews',
  name: 'PendingReviews',
  mixins: [ResourceView, MileageNoticeHelper],
  data() {
    return {
      selectedSortType: null,
      isLoading: true,
      subOrders: [],
      noticeMessage: null
    };
  },
  computed: {
    ...mapState(['api']),
    ...mapState('widget', ['widget', 'brandName']),
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapState('window', ['windowService']),
    DropdownMenuWidth: () => DropdownMenuWidth,
    displayOrderOptions() {
      return this.widget.display_orders_in_use.map(order => ({
        value: order,
        name: ReviewSort.t(order)
      }));
    },
    maxMileage() {
      return this.subOrders.reduce(
        (acc, subOrder) => acc + subOrder.expected_mileage,
        0
      );
    },
    mileageString() {
      return this.maxMileage.toLocaleString() + this.$t('money');
    },
    mileageStyle() {
      return {
        '--highlight-text-color': this.widget
          .my_review_mileage_highlight_text_color
      };
    }
  },
  created() {
    const { sort } = this.resourceParams;
    this.selectedSortType = parseInt(sort || this.widget.display_order);
    this.windowService.addMessageHandler(({ act }) => {
      if (act === 'popstate') this.fetchResource();
    });
  },
  mounted() {
    this.resourceParams = this.filterQuery(this.$route.query);
    this.fetchInitialData();
  },
  methods: {
    async fetchInitialData() {
      try {
        const [{ data }, mileageNotice] = await Promise.all([
          this.api.fetchManagingReviewsPendingReviews(this.resourceParams),
          this.widget.show_mileage_notices
            ? this.fetchMileageNotice()
            : Promise.resolve({ message: null })
        ]);

        this.subOrders = data.sub_orders;
        this.noticeMessage = mileageNotice.message;
      } finally {
        this.isLoading = false;
      }
    },
    fetchResource(params) {
      this.isLoading = true;
      this.api
        .fetchManagingReviewsPendingReviews(params)
        .then(({ data }) => {
          this.subOrders = data.sub_orders;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    productImageUrl(subOrder) {
      return (
        subOrder.product.extra_small_image_url || this.widget.brand_logo_url
      );
    },
    showSubBrandName(subOrder) {
      return (
        this.reviewSettings.use_sub_brand_filter_setting &&
        subOrder.product.sub_brand_name
      );
    },
    showStoreName(subOrder) {
      return this.reviewSettings.show_store_name_prefix && subOrder.store_name;
    },
    showProductOptions(subOrder) {
      return (
        this.reviewSettings.show_options &&
        !!subOrder.product_options &&
        Object.keys(subOrder.product_options).length > 0
      );
    },
    productOptions(subOrder) {
      return this.$t('pending_review.product_options', {
        product_options: Object.values(subOrder.product_options).join(' ・ ')
      });
    },
    newReviewButtonLabel(subOrder) {
      return subOrder.expected_mileage
        ? this.$t('new_review_button_label_with_mileage', {
            expected_mileage: subOrder.expected_mileage
          })
        : this.$t('new_review_button_label');
    },
    endDate(subOrder) {
      return subOrder.pending_review_expires_in
        ? this.$t('pending_review.end_date', {
            end_date: this.formatDate(subOrder.pending_review_expires_in),
            remaining_days: subOrder.remaining_days
          })
        : this.$t('pending_review.no_end_date');
    }
  }
};
